import ActionAbstract from '../ActionAbstract';

class ToggleArrayInspector extends ActionAbstract {

    static get ID() {
        return 'actions:main:toggleArrayInspector';
    }

    run(state) {
        return this.composeState(state, {
            main: {
                arrayInspectorOpen: this.toggle
            }
        });
    }

    toggle(state) {
        let forcedState = this.getParam('open');
        return forcedState !== undefined ? forcedState : !!!state;
    }

}

export default ToggleArrayInspector;